import React from 'react'
import AccountContainer from '../../containers/admin_portal/account';

const AccountPage = () => {
  return <AccountContainer />
}

export default AccountPage;
